import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/shared/lib/utils";

// Base Tabs root
const Tabs = TabsPrimitive.Root;

// Tabs List - the tab bar
const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "inline-flex h-9 items-center justify-center rounded-lg bg-[#0a1628] p-1 text-[#8ba8d4]", // dark navy bg, muted text
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

// Tabs Trigger - each individual tab button
const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50",
      "text-[#8ba8d4] hover:text-[#e8f0fe] hover:bg-[#051127]", // hover: brighter text, slightly lighter bg
      "data-[state=active]:bg-[#0f2044] data-[state=active]:text-[#4f9eff] data-[state=active]:shadow-lg", // active tab: dark navy bg + accent blue text + shadow
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

// Tabs Content - panel under each tab
const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "mt-2 bg-[#0a1628] p-4 rounded-md text-[#e8f0fe] ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4f9eff] focus-visible:ring-offset-2",
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
